import {SPECIAL_GROUP_ROLES } from 'constants-channel';
import { roleMapping } from '../mappers/AccessControl';

// TO BE REMOVED AFTER REFACTORING
export const formatAccessManagerRole = (roles: string[]): string => {
  if (roles.includes(SPECIAL_GROUP_ROLES.ADMIN)) {
    return 'Admin';
  }

  if (roles.includes(SPECIAL_GROUP_ROLES.ACCESS_MANAGER)) {
    return 'AccessAdmin';
  }

  if (roles.includes(SPECIAL_GROUP_ROLES.COMPANY_ACCESS_ADMIN)) {
    return 'CompanyAccessAdmin';
  }

  return '';
};

export const formatAccessUserRoles = (roles: string[] = []): string[] => {
  return roles.map(role => roleMapping[role] || role);
};
